
import React from 'react';
import { connect } from 'react-redux';
import { ClientDashboardCard } from '../../../components/ClientDashboard';
import { CommonHeader } from '../../../components/commons';
import { RootState } from '../../../redux/rootReducers';

type AppProps = {
  history?: any;
  sideMenus:any;
}

const UserLoginSessionReport = ({
  history,
  sideMenus
}: AppProps) => {


  const handleRedirection = (moduleName: string | undefined) => {
    
    switch (moduleName) {
      case 'redirectToDailyActiveUser':
        return redirectToDailyActiveUser();
      case 'redirectToMonthlyActive':
        return redirectToMonthlyActive();
      case 'redirectToSessionLoginCount':
        return redirectToSessionLoginCount();
        case 'redirectToUserReportCount':
          return redirectToUserReportCount();
      default:
        return null;
    }
  };

  const redirectToDailyActiveUser = () => {
    history.push({
      pathname: `/admin-reports/user-login-session-reports/daily-active`,
    });
  };

  const redirectToMonthlyActive = () => {
    history.push({
      pathname: `/admin-reports/user-login-session-reports/monthly-active`,
    });
  };

  const redirectToSessionLoginCount = () => {
    history.push({
      pathname: `/admin-reports/user-login-session-reports/session-login-count`,
    });
  }
  const redirectToUserReportCount = () => {
    history.push({
      pathname: `/admin-reports/user-login-session-reports/user-report`,
    });
  }
  
  let adminReports: any = sideMenus && sideMenus?.length > 0 && sideMenus?.filter((menu:any) => menu?.menu_name === 'Admin Reports');
  let stockManager= adminReports[0].sub_menu && adminReports[0]?.sub_menu.length > 0 && adminReports[0]?.sub_menu?.filter((menu:any) => menu?.menu_name === 'User Login Session Report')


  const renderModule = () => {
    let finalList = stockManager[0]?.sub_menu?.map((list:any) => {
      return (
        <div className={`col-md-4 mb-4 ${ list.extraClasses }`}>
          <ClientDashboardCard
            isNew={list.is_new}
            key={list.menu_name}
            name={list.menu_name}
            description={list.description}
            icon={<i className={list.icon}></i>}
            action={() => handleRedirection(list.action)}
            comingSoon={list.comingSoon}
          />
        </div>
      )
    });

    return finalList;
  };

  return( <>
    <CommonHeader
      title='User Login Session Report'
    />
    <div className="row mt-3">
      {renderModule()}
    </div>
  </>)
};

const mapStateToProps = (state: RootState) => ({
  sideMenus: state.auth.sideMenus
})

export default connect(mapStateToProps) (UserLoginSessionReport);


